import { render, staticRenderFns } from "./FamilyTemplateEdit.vue?vue&type=template&id=4504138e&scoped=true&lang=pug"
import script from "./FamilyTemplateEdit.vue?vue&type=script&lang=ts"
export * from "./FamilyTemplateEdit.vue?vue&type=script&lang=ts"
import style0 from "./FamilyTemplateEdit.vue?vue&type=style&index=0&id=4504138e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4504138e",
  null
  
)

export default component.exports